import * as THREE from "three";
import { isUseLocalModel } from "@/utils/link-detection";
import { APP_ASSETS } from "@/types/supported-venue";

const MODEL_BASE_URL = isUseLocalModel()
  ? "/model/navigation/"
  : `${APP_ASSETS}/venue/xiqu/`;
export const DEFAULT_AVATAR = isUseLocalModel()
  ? MODEL_BASE_URL + "robot.glb"
  : `${APP_ASSETS}/navigation/avatar/robot.glb`;

export const getNearestNumber = (
  dict: Record<number, number>,
  targetPercentage: number,
): number => {
  const entries = Object.entries(dict);
  if (entries.length === 0) return 0;
  const nearest = entries.reduce(
    (closest, [keyStr, value]) => {
      const key = parseFloat(keyStr);
      const diff = Math.abs(key - targetPercentage);
      const closestDiff = Math.abs(closest.key - targetPercentage);
      return diff < closestDiff ? { key, value: Number(value) } : closest;
    },
    { key: parseFloat(entries[0][0]), value: Number(entries[0][1]) },
  );
  return nearest.value;
};

export const getFloorNumber = (
  dict: Record<number, number>,
  targetPercentage: number,
) => {
  const entries = Object.entries(dict);
  if (entries.length === 0) return 0;

  if (targetPercentage == 0) {
    return entries[0][1];
  }
  if (targetPercentage == 1) {
    return entries[entries.length - 1][1];
  }
  for (let i = 0; i < entries.length; i++) {
    if (i == entries.length - 1) {
      return entries[entries.length - 1][1];
    }
    const nextKey = parseFloat(entries[i + 1][0]);
    const currentKey = parseFloat(entries[i][0]);
    if (targetPercentage >= currentKey && targetPercentage < nextKey) {
      return entries[i][1];
    }
  }
  return 0;
};

export const getPreviousNumber = (
  dict: Record<number, number>,
  targetPercentage: number,
) => {
  const entries = Object.entries(dict);
  if (entries.length === 0) return 0;
  if (targetPercentage == 0) {
    return entries[0][1];
  }
  if (targetPercentage == 1) {
    return entries[entries.length - 1][1];
  }
  for (let i = 0; i < entries.length; i++) {
    if (i == entries.length - 1) {
      return entries[entries.length - 1][1];
    }
    const nextKey = parseFloat(entries[i + 1][0]);
    const currentKey = parseFloat(entries[i][0]);
    if (targetPercentage >= currentKey && targetPercentage < nextKey) {
      if(i == 0){
        return 0;
      }
      return entries[i - 1][1];
    }
  }
  return 0;
};

export const getCeilingNumber = (
  dict: Record<number, number>,
  targetPercentage: number,
) => {
  const entries = Object.entries(dict);
  if (entries.length === 0) return 0;

  if (targetPercentage == 0) {
    return entries[0][1];
  }
  if (targetPercentage == 1) {
    return entries[entries.length - 1][1];
  }
  for (let i = 0; i < entries.length; i++) {
    if (i == entries.length - 1) {
      return entries[entries.length - 1][1];
    }
    const nextKey = parseFloat(entries[i + 1][0]);
    const currentKey = parseFloat(entries[i][0]);
    if (targetPercentage >= currentKey && targetPercentage < nextKey) {
      return entries[i+1][1];
    }
  }
  return 0;
};

// export const getCeilingValue = (
//   dict: Record<number, any>,
//   targetPercentage: number,
// ) => {
//   const entries = Object.entries(dict);
//   if (entries.length === 0) return 0;

//   if (targetPercentage == 0) {
//     return entries[0][1];
//   }
//   if (targetPercentage == 1) {
//     return entries[entries.length - 1][1];
//   }
//   for (let i = 0; i < entries.length; i++) {
//     if (i == entries.length - 1) {
//       return entries[entries.length - 1][1];
//     }
//     const nextKey = parseFloat(entries[i + 1][0]);
//     const currentKey = parseFloat(entries[i][0]);
//     if (targetPercentage >= currentKey && targetPercentage < nextKey) {
//       return entries[i+1][1];
//     }
//   }
//   return 0;
// };

// export const getFloorIndex = (
//   dict: Record<number, string>,
//   targetPercentage: number,
// ) => {
//   const entries = Object.entries(dict);
//   if (entries.length === 0) return 0;
//   if (targetPercentage == 0) {
//     return 0;
//   }
//   if (targetPercentage == 1) {
//     return entries.length - 1;
//   }
//   for (let i = 0; i < entries.length; i++) {
//     if (i == entries.length - 1) {
//       return entries.length - 1;
//     }
//     const nextKey = parseFloat(entries[i + 1][0]);
//     const currentKey = parseFloat(entries[i][0]);
//     if (targetPercentage >= currentKey && targetPercentage < nextKey) {
//       return i;
//     }
//   }
//   return 0;
// };

// export const getFloorStringWithIndex = (
//   dict: Record<number, string>,
//   targetPercentage: number,
// ) => {
//   const entries = Object.entries(dict);
//   if (entries.length === 0) return "";

//   if (targetPercentage == 0) {
//     return entries[0][1];
//   }
//   if (targetPercentage == 1) {
//     // return entries[entries.length - 1][1];
//     return {
//       index: entries.length - 1,
//       string: entries[entries.length - 1][1],
//     };
//   }
//   for (let i = 0; i < entries.length; i++) {
//     if (i == entries.length - 1) {
//       // return entries[entries.length - 1][1];
//       return {
//         index: entries.length - 1,
//         string: entries[entries.length - 1][1],
//       };
//     }
//     const nextKey = parseFloat(entries[i + 1][0]);
//     const currentKey = parseFloat(entries[i][0]);
//     if (targetPercentage >= currentKey && targetPercentage < nextKey) {
//       // return entries[i][1];
//       return {
//         index: i,
//         string: entries[i][1],
//       };
//     }
//   }
//   return { index: 0, string: "" };
// };

export const getFloorString = (
  dict: Record<number, string>,
  targetPercentage: number,
) => {
  const entries = Object.entries(dict);
  if (entries.length === 0) return "";

  if (targetPercentage == 0) {
    return entries[0][1];
  }
  if (targetPercentage == 1) {
    return entries[entries.length - 1][1];
  }
  for (let i = 0; i < entries.length; i++) {
    if (i == entries.length - 1) {
      return entries[entries.length - 1][1];
    }
    const nextKey = parseFloat(entries[i + 1][0]);
    const currentKey = parseFloat(entries[i][0]);
    if (targetPercentage >= currentKey && targetPercentage < nextKey) {
      return entries[i][1];
    }
  }
  return "";
};

export const getInterpolatedNumberArray = (
  dict: Record<number, number[]>,
  targetPercentage: number,
): number[] => {
  const sortedEntries = Object.entries(dict)
    .map(([keyStr, value]) => ({ key: parseFloat(keyStr), value }))
    .sort((a, b) => a.key - b.key);

  if (sortedEntries.length < 2) {
    return sortedEntries[0]?.value || [0, 0, 0];
  }

  // Find bracketing points (lower <= target <= upper)
  let lower = sortedEntries[0];
  let upper = sortedEntries[sortedEntries.length - 1];

  for (let i = 0; i < sortedEntries.length - 1; i++) {
    if (
      sortedEntries[i].key <= targetPercentage &&
      sortedEntries[i + 1].key >= targetPercentage
    ) {
      lower = sortedEntries[i];
      upper = sortedEntries[i + 1];
      break;
    }
  }

  // Clamp to bounds if outside range
  if (targetPercentage < sortedEntries[0].key) {
    return lower.value;
  }
  if (targetPercentage > sortedEntries[sortedEntries.length - 1].key) {
    return upper.value;
  }

  // Linear interpolation t = (target - lower) / (upper - lower)
  const t = (targetPercentage - lower.key) / (upper.key - lower.key);

  return [
    lower.value[0] + (upper.value[0] - lower.value[0]) * t,
    lower.value[1] + (upper.value[1] - lower.value[1]) * t,
    lower.value[2] + (upper.value[2] - lower.value[2]) * t,
  ];
};

// export const getLowerNumberArray = (
//   dict: Record<number, number[]>,
//   targetPercentage: number,
// ): number[] => {
//   const sortedEntries = Object.entries(dict)
//     .map(([keyStr, value]) => ({ key: parseFloat(keyStr), value }))
//     .sort((a, b) => a.key - b.key);
//   if (sortedEntries.length === 0) {
//     return [0, 0, 0];
//   }
//   // If target is below the smallest key, return the first value
//   if (targetPercentage <= sortedEntries[0].key) {
//     return sortedEntries[0].value;
//   }
//   // Find the lower bracket (largest key <= target)
//   let lower = sortedEntries[0];
//   for (let i = 0; i < sortedEntries.length; i++) {
//     if (sortedEntries[i].key <= targetPercentage) {
//       lower = sortedEntries[i];
//     } else {
//       break;
//     }
//   }
//   return lower.value;
// };

export const getStartValueArray = (
  dict: Record<number, any[]>,
  targetPercentage: number,
): number[] => {
  const sortedEntries = Object.entries(dict)
    .map(([keyStr, value]) => ({ key: parseFloat(keyStr), value }))
    .sort((a, b) => a.key - b.key);
  if (sortedEntries.length === 0) {
    return [0, 0, 0];
  }
  if (targetPercentage <= sortedEntries[0].key) {
    return sortedEntries[0].value;
  }
  let lowerIndex = 0;
  for (let i = 0; i < sortedEntries.length; i++) {
    if (sortedEntries[i].key <= targetPercentage) {
      lowerIndex = i;
    } else {
      break;
    }
  }
  return sortedEntries[lowerIndex].value
};

export const getEndValueArray = (
  dict: Record<number, any[]>,
  targetPercentage: number,
): number[] => {
  const sortedEntries = Object.entries(dict)
    .map(([keyStr, value]) => ({ key: parseFloat(keyStr), value }))
    .sort((a, b) => a.key - b.key);
  if (sortedEntries.length === 0) {
    return [0, 0, 0];
  }
  if (targetPercentage <= sortedEntries[0].key) {
    return sortedEntries[0].value;
  }
  let lowerIndex = 0;
  for (let i = 0; i < sortedEntries.length; i++) {
    if (sortedEntries[i].key <= targetPercentage) {
      lowerIndex = i;
    } else {
      break;
    }
  }
  if(lowerIndex >= sortedEntries.length - 1){
    return sortedEntries[sortedEntries.length - 1].value
  }
  else{
    return sortedEntries[lowerIndex + 1].value
  }
};

export const getNextEndValueArray = (
  dict: Record<number, any[]>,
  targetPercentage: number,
): number[] => {
  const sortedEntries = Object.entries(dict)
    .map(([keyStr, value]) => ({ key: parseFloat(keyStr), value }))
    .sort((a, b) => a.key - b.key);
  if (sortedEntries.length === 0) {
    return [0, 0, 0];
  }
  if (targetPercentage <= sortedEntries[0].key) {
    return sortedEntries[0].value;
  }
  let lowerIndex = 0;
  for (let i = 0; i < sortedEntries.length; i++) {
    if (sortedEntries[i].key <= targetPercentage) {
      lowerIndex = i;
    } else {
      break;
    }
  }
  if(lowerIndex >= sortedEntries.length - 2){
    return sortedEntries[sortedEntries.length - 1].value
  }
  else{
    return sortedEntries[lowerIndex + 2].value
  }
};

export const getPreviousValueArray = (
  dict: Record<number, any[]>,
  targetPercentage: number,
): number[] => {
  const sortedEntries = Object.entries(dict)
    .map(([keyStr, value]) => ({ key: parseFloat(keyStr), value }))
    .sort((a, b) => a.key - b.key);

  if (sortedEntries.length === 0) {
    return [0, 0, 0];
  }
  if (targetPercentage <= sortedEntries[0].key) {
    return sortedEntries[0].value;
  }

  let lowerIndex = 0;
  for (let i = 0; i < sortedEntries.length; i++) {
    if (sortedEntries[i].key <= targetPercentage) {
      lowerIndex = i;
    } else {
      break;
    }
  }
  if(lowerIndex <= 0){
    return sortedEntries[0].value
  }
  else{
    return sortedEntries[lowerIndex -1].value
  }
};

export const isLastNumberArray = (
  dict: Record<number, number[]>,
  targetPercentage: number,
): boolean => {
  const entries = Object.entries(dict);
  const entriesLength = entries.length - 1;
  const processingDict = entriesLength * targetPercentage;
  console.log(entriesLength + " " + processingDict);
  return processingDict > entriesLength - 2;
};

export const getFloorNumberArray = (
  dict: Record<number, number[]>,
  targetPercentage: number,
) => {
  const entries = Object.entries(dict);
  if (entries.length === 0) {
    return [0, 0, 0];
  }
  if (targetPercentage == 0) {
    return entries[0][1];
  }
  if (targetPercentage == 1) {
    return entries[entries.length - 1][1];
  }
  for (let i = 0; i < entries.length; i++) {
    if (i == entries.length - 1) {
      return entries[entries.length - 1][1];
    }
    const nextKey = parseFloat(entries[i + 1][0]);
    const currentKey = parseFloat(entries[i][0]);
    if (targetPercentage >= currentKey && targetPercentage < nextKey) {
      return entries[i][1];
    }
  }
  return [0, 0, 0];
};

const CHINESE_REGEX = /[\u4E00-\u9FFF]/;
export function hasChinese(obj: any): boolean {
  if (typeof obj === 'string') {
    return CHINESE_REGEX.test(obj);
  }
  if (Array.isArray(obj)) {
    return obj.some(hasChinese);
  }
  if (obj && typeof obj === 'object') {
    return Object.values(obj).some(hasChinese);
  }
  return false;
}

export const initCameraMovement = [
  [0, 0, 3],
  [0, 3.483927e-7, 3.000014],
  [0, 1.576858e-6, 3.000062],
  [0, 3.706425e-6, 3.000146],
  [0, 6.35475e-6, 3.000251],
  [0, 1.020057e-5, 3.000403],
  [2.384186e-7, 1.482982e-5, 3.000586],
  [2.384186e-7, 1.973081e-5, 3.000779],
  [4.768372e-7, 2.651218e-5, 3.001047],
  [7.152557e-7, 3.302277e-5, 3.001304],
  [1.192093e-6, 4.115247e-5, 3.001626],
  [1.66893e-6, 4.922217e-5, 3.001944],
  [2.384186e-6, 5.896267e-5, 3.002329],
  [3.099442e-6, 6.962474e-5, 3.00275],
  [4.291534e-6, 7.990719e-5, 3.003156],
  [5.722046e-6, 9.230999e-5, 3.003646],
  [7.390976e-6, 0.0001053802, 3.004162],
  [9.298325e-6, 0.0001193275, 3.004713],
  [1.168251e-5, 0.0001329713, 3.005252],
  [1.454353e-5, 0.0001488354, 3.005879],
  [1.764297e-5, 0.0001634284, 3.006455],
  [2.145767e-5, 0.0001809542, 3.007148],
  [2.622604e-5, 0.0001992565, 3.00787],
  [3.0756e-5, 0.000216394, 3.008547],
  [3.671646e-5, 0.0002358988, 3.009318],
  [4.339218e-5, 0.0002567052, 3.010139],
  [5.078316e-5, 0.0002780202, 3.010981],
  [5.841255e-5, 0.0002981497, 3.011776],
  [6.79493e-5, 0.0003213465, 3.012693],
  [7.843971e-5, 0.0003453491, 3.013641],
  [8.869171e-5, 0.0003673358, 3.014509],
  [0.0001022816, 0.0003941535, 3.015568],
  [0.0001163483, 0.0004203445, 3.016603],
  [0.0001301765, 0.0004447173, 3.017565],
  [0.0001471043, 0.0004726635, 3.018669],
  [0.0001657009, 0.0005016887, 3.019815],
  [0.0001854897, 0.000530957, 3.020971],
  [0.0002052784, 0.0005585165, 3.02206],
  [0.0002286434, 0.0005895888, 3.023287],
  [0.0002541542, 0.0006216238, 3.024552],
  [0.0002818108, 0.000654519, 3.025851],
  [0.0003085136, 0.0006846725, 3.027042],
  [0.0003404617, 0.0007193715, 3.028412],
  [0.0003750324, 0.0007549021, 3.029816],
  [0.0004122257, 0.0007915357, 3.031262],
  [0.0004470348, 0.0008242999, 3.032556],
  [0.0004897118, 0.0008627548, 3.034075],
  [0.0005347729, 0.0009014978, 3.035604],
  [0.000576973, 0.000936507, 3.036987],
  [0.0006272793, 0.0009763634, 3.038561],
  [0.0006816387, 0.001017813, 3.040197],
  [0.0007383823, 0.001059366, 3.041838],
  [0.0007989407, 0.001101939, 3.043519],
  [0.0008487701, 0.001135736, 3.044853],
  [0.0009236336, 0.001184904, 3.046794],
  [0.000995636, 0.001230147, 3.04858],
  [0.001062632, 0.001270864, 3.050188],
  [0.001142263, 0.00131761, 3.052033],
  [0.001225233, 0.001364692, 3.053892],
  [0.00131321, 0.001412786, 3.05579],
  [0.001406431, 0.001462045, 3.057734],
  [0.001492023, 0.001505968, 3.059468],
  [0.001583815, 0.001551546, 3.061267],
  [0.001701832, 0.00160835, 3.063508],
  [0.001814604, 0.001660755, 3.065576],
  [0.001920462, 0.001708526, 3.067461],
  [0.002043486, 0.001762406, 3.069587],
  [0.002173424, 0.001817549, 3.071763],
  [0.002290487, 0.001865939, 3.073672],
  [0.002430916, 0.001922234, 3.075893],
  [0.002574921, 0.001978364, 3.078107],
  [0.002712011, 0.002030376, 3.080158],
  [0.002869606, 0.002088501, 3.082451],
  [0.003035069, 0.002147926, 3.084795],
  [0.003208876, 0.002208547, 3.087185],
  [0.003371477, 0.00226388, 3.089367],
  [0.003561735, 0.002326867, 3.09185],
  [0.003757715, 0.002390059, 3.094341],
  [0.003937244, 0.002446502, 3.096566],
  [0.004149199, 0.002511459, 3.099126],
  [0.004342318, 0.002569253, 3.101404],
  [0.004569054, 0.00263552, 3.104015],
  [0.004802227, 0.002701924, 3.106632],
  [0.005047083, 0.002769967, 3.109312],
  [0.005271435, 0.002830874, 3.111711],
  [0.005533934, 0.002900539, 3.114455],
  [0.005774975, 0.002963089, 3.116918],
  [0.006055832, 0.003034267, 3.119721],
  [0.006340981, 0.003104906, 3.122502],
  [0.006605387, 0.00316904, 3.125026],
  [0.006912231, 0.003241836, 3.127891],
  [0.007234335, 0.003316497, 3.130829],
  [0.007555485, 0.00338934, 3.133695],
  [0.00785923, 0.003456843, 3.136351],
  [0.00820899, 0.003532963, 3.139344],
  [0.008545399, 0.003604664, 3.142164],
  [0.008911848, 0.0036812, 3.145173],
  [0.009291649, 0.003758828, 3.148224],
  [0.009682655, 0.003837144, 3.151302],
  [0.01004457, 0.003908232, 3.154095],
  [0.01046252, 0.003988774, 3.157259],
  [0.01088643, 0.004068813, 3.160403],
  [0.01132464, 0.004149959, 3.163589],
  [0.01172566, 0.004222841, 3.16645],
  [0.01219487, 0.004306585, 3.169737],
  [0.01267481, 0.004390548, 3.173032],
  [0.01316237, 0.004474272, 3.176316],
  [0.01361036, 0.004549822, 3.179279],
  [0.01413131, 0.004636165, 3.182664],
  [0.01466751, 0.004723368, 3.186082],
  [0.01515603, 0.004801426, 3.189141],
  [0.01571202, 0.004888774, 3.192563],
  [0.01628685, 0.004977489, 3.196037],
  [0.01688004, 0.005067397, 3.199557],
  [0.01748133, 0.005156969, 3.203063],
  [0.01803637, 0.005238264, 3.206244],
  [0.01867962, 0.005330957, 3.209869],
  [0.01932764, 0.005422729, 3.213458],
  [0.01993227, 0.005507007, 3.216752],
  [0.02062106, 0.005601447, 3.220442],
  [0.02132154, 0.0056959, 3.224131],
  [0.02204347, 0.00579165, 3.22787],
  [0.02269673, 0.005876954, 3.2312],
  [0.02344322, 0.005972931, 3.234944],
  [0.02421856, 0.00607102, 3.238769],
  [0.02500153, 0.006168521, 3.24257],
  [0.02568913, 0.006252889, 3.245858],
  [0.02659941, 0.006362877, 3.250142],
  [0.02735972, 0.006453299, 3.253662],
  [0.02821612, 0.006553688, 3.257569],
  [0.02909756, 0.006655414, 3.261526],
  [0.02995014, 0.006752376, 3.265296],
  [0.03090787, 0.006859693, 3.269467],
  [0.03180623, 0.006958833, 3.273317],
  [0.03272891, 0.00705922, 3.277215],
  [0.03369761, 0.007163134, 3.281247],
  [0.0346725, 0.007266193, 3.285244],
  [0.03566551, 0.00736973, 3.289257],
  [0.03666115, 0.007472083, 3.293222],
  [0.03769612, 0.007577047, 3.297287],
  [0.0387466, 0.007682123, 3.301353],
  [0.03990173, 0.007796053, 3.305759],
  [0.04098892, 0.007901778, 3.309845],
  [0.04209948, 0.008008356, 3.313962],
  [0.043257, 0.008117969, 3.318194],
  [0.04440975, 0.008225677, 3.322349],
  [0.0456295, 0.008338165, 3.326686],
  [0.04685068, 0.008449286, 3.330968],
  [0.04807281, 0.008559076, 3.335195],
  [0.04929399, 0.008667408, 3.339364],
  [0.05064082, 0.008785351, 3.343899],
  [0.05194402, 0.008898003, 3.348228],
  [0.05326629, 0.009010865, 3.352561],
  [0.0546155, 0.009124625, 3.356926],
  [0.0559907, 0.009239132, 3.361316],
  [0.0574069, 0.009355631, 3.365779],
  [0.05871844, 0.009462235, 3.36986],
  [0.06040573, 0.00959768, 3.375041],
  [0.06188583, 0.00971496, 3.379523],
  [0.06339765, 0.009833316, 3.384043],
  [0.06493235, 0.009952048, 3.388573],
  [0.06645799, 0.01006872, 3.393021],
  [0.06808138, 0.01019143, 3.397695],
  [0.0697155, 0.01031348, 3.40234],
  [0.07134247, 0.01043361, 3.406907],
  [0.07301998, 0.01055605, 3.411558],
  [0.07472539, 0.01067912, 3.416229],
  [0.07649398, 0.01080529, 3.421013],
  [0.07822561, 0.01092744, 3.425639],
  [0.08000827, 0.0110518, 3.430346],
  [0.08189559, 0.01118199, 3.435267],
  [0.08381724, 0.01131302, 3.440215],
  [0.08570242, 0.01144015, 3.445011],
  [0.08760428, 0.01156701, 3.449791],
  [0.08954191, 0.01169486, 3.454604],
  [0.09153819, 0.01182518, 3.459504],
  [0.09353352, 0.01195403, 3.464345],
  [0.09556103, 0.01208358, 3.469205],
  [0.09760737, 0.01221298, 3.474054],
  [0.09972, 0.01234518, 3.479003],
  [0.1018982, 0.01248005, 3.484045],
  [0.1040509, 0.01261194, 3.48897],
  [0.1062391, 0.01274465, 3.49392],
  [0.1084614, 0.01287805, 3.498889],
  [0.11092, 0.0130241, 3.504322],
  [0.1130583, 0.01314985, 3.508994],
  [0.1154368, 0.01328833, 3.514132],
  [0.1178386, 0.01342677, 3.519263],
  [0.1202607, 0.01356499, 3.524377],
  [0.1228216, 0.01370965, 3.529723],
  [0.1253002, 0.01384825, 3.534837],
  [0.1278434, 0.01398909, 3.540027],
  [0.1303816, 0.01412829, 3.545149],
  [0.132936, 0.01426705, 3.550247],
  [0.13556, 0.01440823, 3.555427],
  [0.1382511, 0.01455164, 3.56068],
  [0.1407084, 0.01468142, 3.565427],
  [0.1436033, 0.01483289, 3.570958],
  [0.146462, 0.01498101, 3.576359],
  [0.1492722, 0.01512525, 3.58161],
  [0.1521363, 0.0152709, 3.586903],
  [0.1551316, 0.01542181, 3.592378],
  [0.1580036, 0.01556517, 3.597571],
  [0.1610065, 0.01571373, 3.602942],
  [0.1639574, 0.0158584, 3.608164],
  [0.1669874, 0.01600564, 3.61347],
  [0.1700563, 0.01615345, 3.618786],
  [0.1732199, 0.01630447, 3.624208],
  [0.1763699, 0.01645353, 3.62955],
  [0.1795933, 0.01660473, 3.634959],
  [0.1830578, 0.01676576, 3.640708],
  [0.186311, 0.01691565, 3.646049],
  [0.1894827, 0.01706056, 3.651202],
  [0.1931126, 0.01722498, 3.657038],
  [0.1965027, 0.01737719, 3.662429],
  [0.1999707, 0.01753159, 3.667886],
  [0.2032874, 0.01767806, 3.673053],
  [0.2071095, 0.01784541, 3.678944],
  [0.2106566, 0.0179994, 3.684353],
  [0.2140052, 0.01814363, 3.689408],
  [0.2180188, 0.01831507, 3.695404],
  [0.2217202, 0.01847184, 3.700874],
  [0.2254674, 0.01862928, 3.706356],
  [0.2292366, 0.01878636, 3.711812],
  [0.2330468, 0.01894391, 3.717273],
  [0.2370484, 0.01910805, 3.722948],
  [0.2409477, 0.01926671, 3.72842],
  [0.2449672, 0.01942899, 3.734004],
  [0.2489886, 0.01959008, 3.739534],
  [0.2530994, 0.01975345, 3.745128],
  [0.2575152, 0.01992755, 3.751074],
  [0.2616785, 0.02009038, 3.75662],
  [0.2658837, 0.02025362, 3.762166],
  [0.2701354, 0.0204174, 3.767716],
  [0.274574, 0.02058709, 3.77345],
  [0.278897, 0.0207511, 3.778978],
  [0.2833214, 0.02091771, 3.784578],
  [0.2877436, 0.02108301, 3.790118],
  [0.2922692, 0.02125093, 3.795731],
  [0.2968109, 0.0214182, 3.801306],
  [0.301688, 0.02159649, 3.807231],
  [0.3063004, 0.02176386, 3.812776],
  [0.3109691, 0.02193205, 3.818332],
  [0.3139968, 0.02204048, 3.821906],
  [0.3206849, 0.02227829, 3.829718],
  [0.3256278, 0.02245254, 3.835421],
  [0.3305161, 0.02262363, 3.841003],
  [0.3354957, 0.02279671, 3.846633],
  [0.3404675, 0.02296832, 3.852196],
  [0.3455508, 0.02314255, 3.857827],
  [0.3506844, 0.0233173, 3.863455],
  [0.355804, 0.02349038, 3.86901],
  [0.3611102, 0.02366854, 3.87471],
  [0.3667824, 0.02385764, 3.880738],
  [0.3720977, 0.02403361, 3.886327],
  [0.3774738, 0.02421039, 3.891922],
  [0.3829582, 0.02438953, 3.897571],
  [0.3883994, 0.02456609, 3.903119],
  [0.3939919, 0.02474636, 3.908762],
  [0.3995421, 0.02492408, 3.914305],
  [0.4051528, 0.02510259, 3.919852],
  [0.4110112, 0.02528776, 3.925583],
  [0.4167531, 0.02546806, 3.931142],
  [0.4217134, 0.0256229, 3.935898],
  [0.4285204, 0.02583403, 3.942358],
  [0.4346116, 0.02602164, 3.948072],
  [0.4406164, 0.0262054, 3.953647],
  [0.4466803, 0.02638981, 3.959217],
  [0.4527183, 0.02657229, 3.964706],
  [0.4589338, 0.02675897, 3.970297],
  [0.4653192, 0.02694955, 3.97598],
  [0.4715297, 0.02713377, 3.981449],
  [0.4778771, 0.02732091, 3.98698],
  [0.4842734, 0.02750834, 3.992495],
  [0.491163, 0.02770896, 3.99837],
  [0.4976842, 0.02789768, 4.00387],
  [0.5041411, 0.02808344, 4.009258],
  [0.5107443, 0.02827228, 4.014711],
  [0.5173564, 0.02846029, 4.020112],
  [0.5243623, 0.02865829, 4.025774],
  [0.5310891, 0.0288473, 4.03115],
  [0.5380409, 0.02904148, 4.036646],
  [0.5448525, 0.02923067, 4.041973],
  [0.5518408, 0.02942365, 4.047379],
  [0.558846, 0.02961601, 4.05274],
  [0.5659499, 0.02980996, 4.058116],
  [0.5736003, 0.03001762, 4.063841],
  [0.5807438, 0.03021042, 4.069125],
  [0.5882173, 0.03041099, 4.074592],
  [0.595346, 0.03060125, 4.079748],
  [0.602762, 0.0307981, 4.085054],
  [0.6100969, 0.03099175, 4.090244],
  [0.6180897, 0.0312016, 4.095833],
  [0.6257024, 0.03140035, 4.101095],
  [0.6332037, 0.03159514, 4.106221],
  [0.6408784, 0.0317934, 4.111407],
  [0.6486137, 0.03199216, 4.116573],
  [0.6567006, 0.03219885, 4.121912],
  [0.6644177, 0.03239504, 4.126947],
  [0.6725192, 0.03259994, 4.132172],
  [0.680552, 0.03280204, 4.137291],
  [0.6885476, 0.03300218, 4.142326],
  [0.6966934, 0.03320503, 4.147397],
  [0.7054155, 0.03342111, 4.152759],
  [0.7136431, 0.03362387, 4.157754],
  [0.7220392, 0.03382974, 4.162791],
  [0.7305045, 0.03403627, 4.167807],
  [0.7388163, 0.03423805, 4.172672],
  [0.7473087, 0.03444321, 4.177583],
  [0.7558994, 0.03464973, 4.182489],
  [0.7650247, 0.03486801, 4.187634],
  [0.773705, 0.03507461, 4.192466],
  [0.7823851, 0.03528022, 4.197237],
  [0.7911956, 0.03548794, 4.202018],
  [0.7966623, 0.03561632, 4.204954],
  [0.8080387, 0.03588231, 4.21099],
  [0.8180099, 0.03611415, 4.2162],
  [0.827172, 0.03632612, 4.220921],
  [0.8362875, 0.03653604, 4.225556],
  [0.8461885, 0.03676298, 4.230521],
  [0.8554389, 0.03697399, 4.235096],
  [0.864866, 0.03718806, 4.239695],
  [0.8740151, 0.0373949, 4.244098],
  [0.8838468, 0.03761616, 4.248765],
  [0.8928728, 0.0378184, 4.25299],
  [0.9025717, 0.03803477, 4.257468],
  [0.9126053, 0.03825762, 4.262034],
  [0.9225502, 0.0384775, 4.266494],
  [0.9304082, 0.03865055, 4.269971],
  [0.9423637, 0.0389127, 4.275185],
  [0.9498501, 0.03907618, 4.278402],
  [0.961972, 0.03933975, 4.283536],
  [0.9719276, 0.03955523, 4.287683],
  [0.9827623, 0.03978872, 4.292127],
  [0.9930143, 0.0400087, 4.296264],
  [1.003346, 0.04022947, 4.300368],
  [1.013628, 0.04044827, 4.30439],
  [1.024221, 0.0406728, 4.308466],
  [1.034387, 0.04088738, 4.312316],
  [1.045036, 0.04111128, 4.316284],
  [1.055654, 0.04133361, 4.320175],
  [1.062261, 0.04147152, 4.322564],
  [1.076786, 0.04177353, 4.327728],
  [1.087698, 0.04199939, 4.33153],
  [1.098634, 0.04222484, 4.335273],
  [1.109553, 0.04244906, 4.338944],
  [1.120538, 0.0426738, 4.342573],
  [1.131658, 0.04290044, 4.346179],
  [1.143252, 0.04313583, 4.349869],
  [1.154571, 0.04336473, 4.353403],
  [1.165685, 0.04358869, 4.356807],
  [1.176999, 0.04381583, 4.360206],
  [1.188456, 0.04404502, 4.363582],
  [1.199753, 0.04427017, 4.366844],
  [1.211811, 0.04450962, 4.370255],
  [1.223166, 0.04473432, 4.373401],
  [1.234676, 0.04496127, 4.376523],
  [1.246816, 0.0451998, 4.379746],
  [1.258434, 0.04542728, 4.382764],
  [1.270114, 0.04565519, 4.385731],
  [1.282443, 0.04589493, 4.388792],
  [1.294631, 0.04613113, 4.391747],
  [1.306507, 0.04636049, 4.394559],
  [1.318595, 0.04659318, 4.397354],
  [1.330614, 0.04682377, 4.400065],
  [1.342814, 0.04705708, 4.402748],
  [1.355176, 0.04729273, 4.405398],
  [1.367352, 0.04752408, 4.40794],
  [1.379762, 0.04775913, 4.410462],
  [1.392467, 0.047999, 4.412973],
  [1.405214, 0.0482389, 4.415421],
  [1.417645, 0.04847214, 4.417738],
  [1.425579, 0.04862062, 4.419182],
  [1.443023, 0.0489461, 4.422261],
  [1.456585, 0.04919822, 4.424564],
  [1.469427, 0.0494362, 4.426672],
  [1.482332, 0.04967467, 4.42872],
  [1.495147, 0.04991077, 4.430684],
  [1.506149, 0.05011294, 4.432315],
  [1.521268, 0.05038993, 4.434474],
  [1.534176, 0.05062574, 4.436243],
  [1.547316, 0.05086507, 4.437974],
  [1.561163, 0.05111659, 4.439721],
  [1.574579, 0.05135959, 4.441339],
  [1.587965, 0.05160139, 4.442883],
  [1.600294, 0.0518235, 4.44424],
  [1.614613, 0.0520808, 4.44574],
  [1.628356, 0.05232706, 4.447104],
  [1.641993, 0.05257079, 4.448384],
  [1.655938, 0.05281936, 4.449618],
  [1.669721, 0.05306442, 4.450763],
  [1.683669, 0.05331178, 4.451847],
  [1.697632, 0.05355877, 4.452857],
  [1.711978, 0.05381189, 4.453817],
  [1.725803, 0.05405523, 4.454668],
  [1.739865, 0.05430213, 4.45546],
  [1.753891, 0.05454783, 4.456176],
  [1.768125, 0.05479659, 4.456826],
  [1.782366, 0.05504488, 4.457401],
  [1.796789, 0.05529575, 4.457908],
  [1.811298, 0.05554754, 4.45834],
  [1.826124, 0.05580425, 4.458701],
  [1.840393, 0.05605074, 4.458973],
  [1.854818, 0.05629941, 4.459172],
  [1.868936, 0.05654225, 4.459295],
  [1.884249, 0.0568051, 4.459346],
  [1.899185, 0.05706091, 4.459314],
  [1.913738, 0.05730963, 4.459208],
  [1.928348, 0.05755884, 4.459024],
  [1.943258, 0.05781265, 4.458759],
  [1.957961, 0.05806242, 4.458421],
  [1.973086, 0.05831887, 4.457994],
  [1.987888, 0.05856936, 4.457497],
  [2.002854, 0.05882216, 4.456918],
  [2.018936, 0.05909326, 4.456208],
  [2.034085, 0.05934817, 4.455458],
  [2.04883, 0.05959581, 4.454651],
  [2.064077, 0.05985145, 4.453738],
  [2.079486, 0.06010935, 4.452734],
  [2.09483, 0.06036572, 4.451653],
  [2.110036, 0.06061934, 4.450503],
  [2.12652, 0.06089381, 4.449168],
  [2.141822, 0.06114819, 4.447845],
  [2.157398, 0.0614067, 4.446417],
  [2.172694, 0.06166014, 4.444936],
  [2.18834, 0.06191901, 4.443338],
  [2.203647, 0.06217187, 4.441696],
  [2.219482, 0.06243308, 4.439915],
  [2.236501, 0.06271338, 4.437906],
  [2.252243, 0.06297228, 4.435963],
  [2.268156, 0.06323361, 4.433914],
  [2.28394, 0.06349248, 4.431799],
  [2.299722, 0.06375095, 4.429602],
  [2.316235, 0.06402105, 4.427214],
  [2.332075, 0.06427979, 4.424839],
  [2.348433, 0.06454669, 4.422299],
  [2.364718, 0.06481204, 4.419683],
  [2.380813, 0.065074, 4.417013],
  [2.396947, 0.06533627, 4.41425],
  [2.412835, 0.06559428, 4.411445],
  [2.429357, 0.06586227, 4.408442],
  [2.445404, 0.06612227, 4.405438],
  [2.461782, 0.06638738, 4.402287],
  [2.479103, 0.06666744, 4.398858],
  [2.49546, 0.06693166, 4.39553],
  [2.51162, 0.06719246, 4.392157],
  [2.52923, 0.06747638, 4.388384],
  [2.54572, 0.06774199, 4.384759],
  [2.562355, 0.06800973, 4.381012],
  [2.578982, 0.0682771, 4.377178],
  [2.595593, 0.06854401, 4.373257],
  [2.610311, 0.06878033, 4.369709],
  [2.629584, 0.06908958, 4.364954],
  [2.646394, 0.06935907, 4.360709],
  [2.663023, 0.0696255, 4.35642],
  [2.679799, 0.06989411, 4.352],
  [2.6967, 0.07016457, 4.347456],
  [2.713734, 0.070437, 4.342781],
  [2.730484, 0.07070472, 4.338092],
  [2.741231, 0.07087645, 4.335036],
  [2.764804, 0.07125289, 4.328199],
  [2.781851, 0.07152498, 4.323142],
  [2.798652, 0.07179305, 4.318064],
  [2.815858, 0.07206745, 4.312769],
  [2.83413, 0.07235873, 4.30704],
  [2.851393, 0.07263388, 4.301526],
  [2.868571, 0.07290757, 4.295943],
  [2.885597, 0.07317877, 4.290314],
  [2.902783, 0.07345247, 4.284534],
  [2.919893, 0.0737249, 4.278683],
  [2.937307, 0.07400215, 4.272628],
  [2.954613, 0.07427762, 4.266512],
  [2.972164, 0.07455698, 4.260208],
  [2.989641, 0.07483512, 4.253829],
  [3.006816, 0.07510848, 4.247461],
  [3.024102, 0.0753836, 4.240952],
  [3.042583, 0.07567775, 4.233883],
  [3.060053, 0.07595585, 4.227096],
  [3.077824, 0.07623875, 4.220086],
  [3.095115, 0.07651406, 4.213163],
  [3.11281, 0.07679585, 4.205976],
  [3.130429, 0.07707649, 4.198712],
  [3.14775, 0.07735247, 4.191469],
  [3.165195, 0.07763049, 4.18407],
  [3.18234, 0.07790381, 4.176698],
  [3.20043, 0.07819232, 4.16881],
  [3.217916, 0.0784713, 4.161078],
  [3.235949, 0.07875913, 4.152994],
  [3.253576, 0.0790406, 4.144983],
  [3.270987, 0.07931877, 4.136965],
  [3.288313, 0.07959574, 4.12888],
  [3.306273, 0.079883, 4.120389],
  [3.32382, 0.08016382, 4.111983],
  [3.342657, 0.08046547, 4.102839],
  [3.359478, 0.08073506, 4.094566],
  [3.377062, 0.08101705, 4.085812],
  [3.394876, 0.08130293, 4.07683],
  [3.412655, 0.08158851, 4.067752],
  [3.431526, 0.08189185, 4.057992],
  [3.449123, 0.08217499, 4.048775],
  [3.466764, 0.08245908, 4.039421],
  [3.484218, 0.08274043, 4.030054],
  [3.501721, 0.08302286, 4.020548],
  [3.519318, 0.08330705, 4.010879],
  [3.537133, 0.08359507, 4.000971],
  [3.555623, 0.08389437, 3.990563],
  [3.573328, 0.08418127, 3.980477],
  [3.591144, 0.08447032, 3.970207],
  [3.608087, 0.08474553, 3.96033],
  [3.626958, 0.08505244, 3.9492],
  [3.644345, 0.08533559, 3.938823],
  [3.662157, 0.08562606, 3.928071],
  [3.679636, 0.08591146, 3.917402],
  [3.697191, 0.08619852, 3.906564],
  [3.71507, 0.08649129, 3.895403],
  [3.732663, 0.08677984, 3.884296],
  [3.750192, 0.08706776, 3.873106],
  [3.767516, 0.08735273, 3.861928],
  [3.78611, 0.08765911, 3.849794],
  [3.803518, 0.08794644, 3.838307],
  [3.820925, 0.08823424, 3.826697],
  [3.838748, 0.08852942, 3.814679],
  [3.857255, 0.08883648, 3.80206],
  [3.87399, 0.08911467, 3.790525],
  [3.892731, 0.08942677, 3.777469],
  [3.910336, 0.08972054, 3.765068],
  [3.926703, 0.08999417, 3.753419],
  [3.944212, 0.09028748, 3.740829],
  [3.962849, 0.09060033, 3.727281],
  [3.980308, 0.09089401, 3.714452],
  [3.997003, 0.09117543, 3.702059],
  [4.015265, 0.09148394, 3.688359],
  [4.030035, 0.091734, 3.677169],
  [4.050463, 0.09208064, 3.661528],
  [4.067713, 0.09237406, 3.648172],
  [4.084831, 0.09266593, 3.634783],
  [4.102026, 0.09295983, 3.621195],
  [4.119197, 0.093254, 3.607488],
  [4.13655, 0.09355207, 3.593493],
  [4.153583, 0.09384535, 3.579616],
  [4.168056, 0.09409515, 3.567714],
  [4.186517, 0.0944146, 3.552383],
  [4.205161, 0.09473813, 3.536731],
  [4.22228, 0.09503606, 3.522206],
  [4.240459, 0.09535336, 3.506619],
  [4.257687, 0.09565493, 3.491693],
  [4.274579, 0.09595147, 3.47691],
  [4.291444, 0.09624843, 3.462002],
  [4.301944, 0.09643374, 3.452645],
  [4.32484, 0.09683904, 3.432039],
  [4.340277, 0.09711327, 3.417987],
  [4.358824, 0.0974438, 3.400933],
  [4.375385, 0.09773991, 3.385545],
  [4.393147, 0.09805854, 3.368872],
  [4.409766, 0.09835769, 3.353111],
  [4.426071, 0.09865216, 3.337495],
  [4.442694, 0.09895337, 3.321417],
  [4.459557, 0.09926002, 3.304944],
  [4.475678, 0.09955423, 3.289035],
  [4.491704, 0.09984768, 3.273069],
  [4.509483, 0.1001745, 3.255174],
  [4.525783, 0.1004752, 3.238597],
  [4.541799, 0.1007718, 3.222149],
  [4.558068, 0.1010742, 3.205276],
  [4.574216, 0.1013755, 3.188361],
  [4.59012, 0.1016735, 3.171538],
  [4.607406, 0.1019986, 3.153063],
  [4.623201, 0.1022969, 3.136009],
  [4.639396, 0.102604, 3.118351],
  [4.655592, 0.1029125, 3.100511],
  [4.671697, 0.1032205, 3.082592],
  [4.687359, 0.1035213, 3.06499],
  [4.703062, 0.1038243, 3.047167],
  [4.718816, 0.1041295, 3.029105],
  [4.734318, 0.1044312, 3.011158],
  [4.750054, 0.1047388, 2.992754],
  [4.765524, 0.1050427, 2.974478],
  [4.780847, 0.105345, 2.956197],
  [4.7966, 0.1056573, 2.937209],
  [4.812516, 0.1059744, 2.917826],
  [4.827657, 0.1062776, 2.899196],
  [4.842825, 0.1065827, 2.880347],
  [4.857854, 0.1068866, 2.861479],
  [4.87396, 0.107214, 2.841047],
  [4.888843, 0.107518, 2.82197],
  [4.903835, 0.107826, 2.802554],
  [4.918495, 0.1081287, 2.783374],
  [4.932182, 0.1084127, 2.765293],
  [4.948919, 0.108762, 2.742947],
  [4.963634, 0.1090709, 2.723081],
  [4.977826, 0.1093705, 2.703727],
  [4.992481, 0.1096816, 2.683532],
  [5.007069, 0.1099931, 2.66322],
  [5.021654, 0.1103063, 2.642695],
  [5.036441, 0.1106258, 2.621662],
  [5.050528, 0.1109321, 2.601411],
  [5.064884, 0.111246, 2.580553],
  [5.078895, 0.1115544, 2.559978],
  [5.092783, 0.1118619, 2.539367],
  [5.106894, 0.1121764, 2.5182],
  [5.120522, 0.112482, 2.497538],
  [5.13414, 0.1127894, 2.476669],
  [5.148282, 0.1131108, 2.45476],
  [5.161901, 0.1134224, 2.433426],
  [5.175286, 0.1137306, 2.41223],
  [5.189381, 0.1140576, 2.389659],
  [5.202611, 0.1143667, 2.368233],
  [5.215726, 0.1146752, 2.346759],
  [5.228838, 0.1149858, 2.325052],
  [5.242589, 0.115314, 2.302023],
  [5.255534, 0.1156253, 2.280097],
  [5.268407, 0.1159372, 2.258043],
  [5.281155, 0.1162485, 2.235953],
  [5.293899, 0.116562, 2.213619],
  [5.306581, 0.1168764, 2.191133],
  [5.318984, 0.1171863, 2.16889],
  [5.331544, 0.1175027, 2.1461],
  [5.344822, 0.11784, 2.121713],
  [5.355115, 0.1181035, 2.102591],
  [5.369364, 0.1184714, 2.075805],
  [5.37775, 0.1186897, 2.059865],
  [5.393313, 0.1190981, 2.029925],
  [5.405218, 0.1194138, 2.0067],
  [5.417224, 0.1197349, 1.982989],
  [5.42892, 0.1200506, 1.9596],
  [5.44038, 0.1203628, 1.936397],
  [5.451819, 0.1206773, 1.912947],
  [5.463214, 0.1209935, 1.889295],
  [5.474378, 0.1213062, 1.865828],
  [5.485645, 0.1216249, 1.841837],
  [5.497274, 0.1219572, 1.816748],
  [5.503503, 0.1221366, 1.803165],
  [5.519397, 0.1225991, 1.768048],
  [5.530186, 0.122917, 1.743817],
  [5.540707, 0.1232303, 1.719872],
  [5.547147, 0.1234237, 1.705056],
  [5.559341, 0.1237933, 1.676665],
  [5.572128, 0.124186, 1.646398],
  [5.582238, 0.1245004, 1.622095],
  [5.592499, 0.124823, 1.597082],
  [5.602326, 0.1251356, 1.572784],
  [5.612717, 0.1254701, 1.546715],
  [5.622462, 0.1257875, 1.521903],
  [5.632072, 0.1261043, 1.497079],
  [5.641592, 0.126422, 1.472121],
  [5.651096, 0.1267432, 1.446829],
  [5.660541, 0.1270664, 1.421307],
  [5.669735, 0.1273851, 1.396079],
  [5.678711, 0.1277004, 1.371068],
  [5.687924, 0.1280282, 1.344991],
  [5.696744, 0.1283465, 1.31962],
  [5.705397, 0.128663, 1.294331],
  [5.714094, 0.1289855, 1.268498],
  [5.722964, 0.1293194, 1.241703],
  [5.731232, 0.1296351, 1.216298],
  [5.739401, 0.1299517, 1.190773],
  [5.747479, 0.1302695, 1.165101],
  [5.756091, 0.1306136, 1.137239],
  [5.763912, 0.1309312, 1.111469],
  [5.771521, 0.1312451, 1.085949],
  [5.779161, 0.1315654, 1.059861],
  [5.786705, 0.1318869, 1.033617],
  [5.794622, 0.1322302, 1.005539],
  [5.801836, 0.1325487, 0.9794447],
  [5.80875, 0.1328592, 0.9539558],
  [5.815941, 0.133188, 0.926919],
  [5.822691, 0.1335023, 0.9010259],
  [5.829613, 0.1338307, 0.8739232],
  [5.836616, 0.1341696, 0.8459062],
  [5.843112, 0.1344904, 0.8193426],
  [5.849615, 0.134818, 0.7921692],
  [5.85593, 0.1351428, 0.7651793],
  [5.862011, 0.1354623, 0.7385973],
  [5.86808, 0.135788, 0.7114518],
  [5.874154, 0.1361214, 0.6836245],
  [5.879747, 0.1364355, 0.6573701],
  [5.885617, 0.1367729, 0.6291288],
  [5.890935, 0.1370859, 0.6028861],
  [5.89637, 0.1374138, 0.5753682],
  [5.901798, 0.1377496, 0.5471374],
  [5.906903, 0.1380741, 0.5198331],
  [5.91167, 0.138385, 0.4936349],
  [5.916514, 0.1387095, 0.4662575],
  [5.9214, 0.1390463, 0.4378063],
  [5.925947, 0.1393692, 0.4104973],
  [5.929465, 0.1396258, 0.3887755],
  [5.934824, 0.1400292, 0.3545941],
  [5.939041, 0.1403583, 0.3266684],
  [5.943099, 0.1406858, 0.2988524],
  [5.947002, 0.1410119, 0.2711289],
  [5.950734, 0.141335, 0.2436347],
  [5.954382, 0.1416629, 0.2157103],
  [5.95785, 0.1419868, 0.1880958],
  [5.961242, 0.1423167, 0.1599498],
  [5.964402, 0.1426373, 0.132576],
  [5.967374, 0.1429519, 0.1056969],
  [5.970456, 0.1432936, 0.07647577],
  [5.973339, 0.1436297, 0.04771358],
  [5.975983, 0.1439542, 0.01991996],
  [5.978524, 0.1442834, -0.008281827],
  [5.98086, 0.1446037, -0.03574783],
  [5.983159, 0.1449385, -0.0644685],
  [5.985238, 0.1452614, -0.09219038],
  [5.987205, 0.1455886, -0.120283],
  [5.989075, 0.1459239, -0.1490883],
  [5.990736, 0.1462467, -0.1768432],
  [5.992291, 0.1465763, -0.2051839],
  [5.993735, 0.1469135, -0.2341885],
  [5.994994, 0.1472413, -0.2623901],
  [5.996099, 0.147565, -0.290251],
  [5.997079, 0.1478929, -0.3184825],
  [5.997918, 0.1482208, -0.3467236],
  [5.99861, 0.1485463, -0.3747577],
  [5.999187, 0.1488883, -0.4042194],
  [5.999574, 0.1491947, -0.4306156],
  [5.99985, 0.1495228, -0.4588824],
  [5.999987, 0.1498597, -0.4879136],
  [5.999976, 0.1501935, -0.5166731],
  [5.999822, 0.15052, -0.5448101],
  [5.999522, 0.1508525, -0.5734501],
  [5.99908, 0.1511829, -0.6019183],
  [5.998488, 0.1515157, -0.6305878],
  [5.997849, 0.151808, -0.6557547],
  [5.996898, 0.1521716, -0.687065],
  [5.995893, 0.1524986, -0.7152252],
  [5.994712, 0.1528355, -0.7442204],
  [5.993422, 0.1531627, -0.772367],
  [5.991963, 0.1534958, -0.8010223],
  [5.990399, 0.1538209, -0.8289759],
  [5.988672, 0.1541506, -0.8573055],
  [5.986804, 0.15448, -0.8856035],
  [5.98489, 0.1547941, -0.912577],
  [5.982548, 0.1551527, -0.9433547],
  [5.980433, 0.1554563, -0.9694003],
  [5.977862, 0.1558041, -0.9992144],
  [5.975229, 0.15614, -1.027993],
  [5.973088, 0.1564002, -1.050274],
  [5.96958, 0.1568053, -1.084936],
  [5.9666, 0.1571314, -1.112813],
  [5.963384, 0.1574674, -1.141523],
  [5.960087, 0.1577972, -1.169669],
  [5.956554, 0.1581357, -1.198543],
  [5.952988, 0.1584638, -1.226508],
  [5.949164, 0.1588023, -1.255328],
  [5.945289, 0.1591327, -1.283427],
  [5.941272, 0.159463, -1.311498],
  [5.937141, 0.1597913, -1.339364],
  [5.932736, 0.1601299, -1.368077],
  [5.928295, 0.1604602, -1.396065],
  [5.923696, 0.1607919, -1.424126],
  [5.918979, 0.1611219, -1.452018],
  [5.914058, 0.1614562, -1.48024],
  [5.909014, 0.1617893, -1.508322],
  [5.90393, 0.1621159, -1.535826],
  [5.898704, 0.162443, -1.563331],
  [5.895283, 0.1626525, -1.580932],
  [5.88744, 0.1631207, -1.620211],
  [5.881683, 0.1634542, -1.648142],
  [5.875852, 0.163784, -1.675721],
  [5.869771, 0.16412, -1.703774],
  [5.86401, 0.1644313, -1.729729],
  [5.857596, 0.1647703, -1.757954],
  [5.851274, 0.1650974, -1.78514],
  [5.844696, 0.1654305, -1.812781],
  [5.838008, 0.1657622, -1.840264],
  [5.831113, 0.1660973, -1.867976],
  [5.824114, 0.1664307, -1.895501],
  [5.816935, 0.1667661, -1.923138],
  [5.809794, 0.1670935, -1.950065],
  [5.802334, 0.1674291, -1.977624],
  [5.794785, 0.1677627, -2.004958],
  [5.787103, 0.168096, -2.032223],
  [5.779378, 0.1684255, -2.059113],
  [5.771036, 0.1687751, -2.08759],
  [5.763067, 0.1691033, -2.114275],
  [5.754748, 0.1694404, -2.141618],
  [5.746518, 0.1697686, -2.16818],
  [5.737864, 0.1701082, -2.195608],
  [5.729288, 0.1704395, -2.22231],
  [5.721044, 0.1707533, -2.247541],
  [5.711759, 0.1711016, -2.275477],
  [5.702779, 0.1714332, -2.302026],
  [5.693565, 0.1717687, -2.328811],
  [5.68426, 0.1721027, -2.355413],
  [5.674832, 0.1724364, -2.381924],
  [5.665726, 0.1727544, -2.407129],
  [5.659462, 0.1729708, -2.424244],
  [5.645629, 0.1734421, -2.461426],
  [5.636392, 0.173752, -2.485801],
  [5.62625, 0.1740881, -2.512163],
  [5.615716, 0.1744327, -2.539121],
  [5.605532, 0.1747617, -2.564783],
  [5.595308, 0.175088, -2.590171],
  [5.58453, 0.1754279, -2.616539],
  [5.573751, 0.1757637, -2.642518],
  [5.562773, 0.1761018, -2.668592],
  [5.551857, 0.1764341, -2.694142],
  [5.540555, 0.1767743, -2.720222],
  [5.529554, 0.1771017, -2.745245],
  [5.518142, 0.1774377, -2.770847],
  [5.506878, 0.1777658, -2.795765],
  [5.495139, 0.1781041, -2.82138],
  [5.483642, 0.178432, -2.846127],
  [5.471756, 0.1787675, -2.871367],
  [5.459723, 0.1791037, -2.896573],
  [5.447567, 0.17944, -2.921702],
  [5.436255, 0.1797499, -2.944783],
  [5.423873, 0.1800859, -2.969728],
  [5.410772, 0.180438, -2.995768],
  [5.398216, 0.1807722, -3.020395],
  [5.389684, 0.1809975, -3.03695],
  [5.373552, 0.1814198, -3.067863],
  [5.360358, 0.1817615, -3.09278],
  [5.34836, 0.1820697, -3.115164],
  [5.334836, 0.182414, -3.140084],
  [5.320916, 0.1827652, -3.165403],
  [5.30723, 0.1831075, -3.189979],
  [5.294831, 0.183415, -3.211976],
  [5.280532, 0.1837668, -3.237039],
  [5.267651, 0.1840812, -3.259345],
  [5.253646, 0.1844202, -3.28331],
  [5.239252, 0.1847658, -3.307638],
  [5.22641, 0.1850718, -3.329089],
  [5.211682, 0.1854202, -3.353407],
  [5.197222, 0.1857595, -3.376989],
  [5.183932, 0.1860691, -3.398416],
  [5.169158, 0.1864108, -3.421964],
  [5.153996, 0.1867587, -3.445838],
  [5.139016, 0.1871, -3.469143],
  [5.125316, 0.18741, -3.490218],
  [5.11672, 0.1876034, -3.503324],
  [5.095648, 0.1880744, -3.535089],
  [5.080413, 0.1884121, -3.557736],
  [5.064458, 0.1887633, -3.581175],
  [5.050661, 0.189065, -3.601218],
  [5.034664, 0.1894127, -3.624204],
  [5.020438, 0.1897199, -3.644415],
  [5.003694, 0.1900791, -3.667938],
  [4.987883, 0.1904162, -3.689893],
  [4.972189, 0.1907487, -3.711437],
  [4.955935, 0.1910909, -3.733501],
  [4.94061, 0.1914116, -3.754074],
  [4.924874, 0.1917391, -3.774969],
  [4.908179, 0.1920845, -3.79689],
  [4.891724, 0.1924229, -3.818254],
  [4.876522, 0.1927338, -3.837778],
  [4.859624, 0.1930775, -3.859244],
  [4.844177, 0.19339, -3.878656],
  [4.827116, 0.1937333, -3.899867],
  [4.8107, 0.1940618, -3.920047],
  [4.794393, 0.1943865, -3.939882],
  [4.7769, 0.194733, -3.960923],
  [4.75951, 0.1950756, -3.981605],
  [4.742436, 0.1954103, -4.001686],
  [4.726924, 0.1957129, -4.019741],
  [4.708987, 0.1960611, -4.040396],
  [4.691487, 0.1963992, -4.060323],
  [4.675533, 0.196706, -4.078297],
  [4.656714, 0.1970661, -4.099269],
  [4.639379, 0.1973963, -4.11837],
  [4.623219, 0.1977028, -4.135992],
  [4.604804, 0.1980505, -4.155858],
  [4.586709, 0.1983905, -4.175159],
  [4.570144, 0.1987005, -4.192642],
  [4.551676, 0.1990447, -4.211926],
  [4.53306, 0.1993902, -4.231144],
  [4.516602, 0.1996943, -4.247954],
  [4.496973, 0.2000556, -4.267786],
  [4.479096, 0.2003833, -4.285643],
  [4.462006, 0.2006954, -4.302537],
  [4.445224, 0.2010007, -4.318956],
  [4.42453, 0.2013757, -4.338978],
  [4.407694, 0.2016797, -4.355085],
  [4.388389, 0.2020269, -4.373357],
  [4.369258, 0.2023697, -4.391254],
  [4.351932, 0.2026792, -4.407292],
  [4.3331, 0.2030143, -4.424536],
  [4.315016, 0.2033351, -4.440914],
  [4.295278, 0.203684, -4.458593],
  [4.277735, 0.203993, -4.474132],
  [4.258362, 0.2043332, -4.491106],
  [4.238898, 0.204674, -4.507965],
  [4.221449, 0.2049784, -4.522916],
  [4.200616, 0.2053408, -4.540563],
  [4.182603, 0.2056532, -4.555648],
  [4.162799, 0.2059956, -4.572049],
  [4.145251, 0.2062982, -4.586422],
  [4.125391, 0.2066397, -4.602509],
  [4.105214, 0.2069856, -4.618662],
  [4.087303, 0.2072919, -4.632839],
  [4.067361, 0.2076319, -4.648447],
  [4.047413, 0.2079712, -4.663876],
  [4.029243, 0.2082795, -4.677773],
  [4.009284, 0.2086172, -4.692862],
  [3.988959, 0.2089603, -4.708047],
  [3.971172, 0.2092598, -4.721183],
  [3.950616, 0.2096051, -4.736191],
  [3.930303, 0.2099456, -4.750842],
  [3.91204, 0.210251, -4.76386],
  [3.891751, 0.2105896, -4.778156],
  [3.871263, 0.2109307, -4.792413],
  [3.853261, 0.2112298, -4.804796],
  [3.833786, 0.2115528, -4.818037],
  [3.8157, 0.2118522, -4.830195],
  [3.792777, 0.2122309, -4.84541],
  [3.772388, 0.212567, -4.858763],
  [3.753886, 0.2128715, -4.870734],
  [3.733154, 0.2132121, -4.883986],
  [3.712567, 0.2135497, -4.896973],
  [3.694116, 0.2138518, -4.908471],
  [3.673317, 0.2141917, -4.921272],
  [3.656831, 0.2144608, -4.931299],
  [3.635716, 0.214805, -4.943988],
  [3.61263, 0.2151806, -4.957664],
  [3.593495, 0.2154915, -4.968844],
  [3.574301, 0.215803, -4.979919],
  [3.554243, 0.216128, -4.991344],
  [3.533666, 0.216461, -5.00291],
  [3.512372, 0.2168052, -5.014709],
  [3.491152, 0.2171477, -5.026302],
  [3.471885, 0.2174584, -5.036685],
  [3.452876, 0.2177646, -5.046794],
  [3.431467, 0.2181091, -5.058024],
  [3.412371, 0.2184161, -5.067899],
  [3.391336, 0.2187539, -5.078624],
  [3.370327, 0.219091, -5.089179],
  [3.351458, 0.2193935, -5.098524],
  [3.330251, 0.2197332, -5.108876],
  [3.309337, 0.220068, -5.118929],
  [3.290459, 0.2203699, -5.127872],
  [3.26932, 0.2207079, -5.137738],
  [3.250243, 0.2210126, -5.146506],
  [3.228658, 0.2213573, -5.156277],
  [3.207585, 0.2216935, -5.165659],
  [3.188804, 0.2219931, -5.173892],
  [3.166972, 0.2223412, -5.183311],
  [3.147105, 0.2226578, -5.191741],
  [3.128213, 0.2229588, -5.199631],
  [3.107136, 0.2232945, -5.208293],
  [3.085866, 0.2236332, -5.216879],
  [3.06705, 0.2239328, -5.224349],
  [3.045033, 0.2242833, -5.232938],
  [3.02624, 0.2245824, -5.240141],
  [3.005359, 0.2249147, -5.248006],
  [2.984285, 0.2252501, -5.255795],
  [2.965342, 0.2255516, -5.262672],
  [2.944583, 0.225882, -5.270069],
  [2.92345, 0.2262185, -5.277454],
  [2.904616, 0.2265184, -5.283913],
  [2.883757, 0.2268505, -5.290926],
  [2.864621, 0.2271554, -5.297236],
  [2.843783, 0.2274874, -5.30397],
  [2.822872, 0.2278207, -5.310585],
  [2.804136, 0.2281195, -5.316389],
  [2.783254, 0.2284527, -5.322722],
  [2.762266, 0.2287876, -5.328944],
  [2.743566, 0.2290863, -5.334367],
  [2.722722, 0.2294193, -5.340278],
  [2.701818, 0.2297536, -5.346061],
  [2.682971, 0.2300551, -5.351155],
  [2.662307, 0.230386, -5.356607],
  [2.643653, 0.2306849, -5.361408],
  [2.623197, 0.2310129, -5.366544],
  [2.602415, 0.2313464, -5.371622],
  [2.583799, 0.2316455, -5.376051],
  [2.563253, 0.2319758, -5.380808],
  [2.542738, 0.232306, -5.385422],
  [2.52846, 0.232536, -5.388552],
  [2.50439, 0.2329242, -5.393677],
  [2.483881, 0.2332554, -5.397896],
  [2.46337, 0.2335869, -5.401977],
  [2.445069, 0.2338831, -5.405502],
  [2.424581, 0.2342152, -5.40932],
  [2.406366, 0.2345108, -5.412598],
  [2.386086, 0.2348402, -5.41612],
  [2.365581, 0.2351739, -5.419543],
  [2.347461, 0.2354692, -5.422454],
  [2.327051, 0.2358022, -5.425601],
  [2.309031, 0.2360967, -5.428267],
  [2.288838, 0.2364273, -5.431127],
  [2.268666, 0.236758, -5.433847],
  [2.250882, 0.2370501, -5.436134],
  [2.230705, 0.2373821, -5.438602],
  [2.212949, 0.2376747, -5.440661],
  [2.192972, 0.2380044, -5.44285],
  [2.173213, 0.2383313, -5.444884],
  [2.155163, 0.2386304, -5.446629],
  [2.135341, 0.2389595, -5.448414],
  [2.115694, 0.2392864, -5.450056],
  [2.098022, 0.239581, -5.451419],
  [2.078348, 0.2399097, -5.45281],
  [2.060543, 0.2402078, -5.453957],
  [2.040978, 0.240536, -5.45509],
  [2.023614, 0.240828, -5.455985],
  [2.004053, 0.2411576, -5.456868],
  [1.986443, 0.2414551, -5.457549],
  [1.966809, 0.2417875, -5.45818],
  [1.949528, 0.2420808, -5.458625],
  [1.93039, 0.2424064, -5.458993],
  [1.911168, 0.2427342, -5.459232],
  [1.900409, 0.2429182, -5.45931],
  [1.87482, 0.2433567, -5.459325],
  [1.857901, 0.2436475, -5.459206],
  [1.83903, 0.2439728, -5.458951],
  [1.820186, 0.2442985, -5.458567],
  [1.803257, 0.244592, -5.458111],
  [1.784653, 0.2449153, -5.457487],
  [1.76784, 0.2452084, -5.456814],
  [1.749368, 0.2455313, -5.455953],
  [1.730909, 0.245855, -5.454965],
  [1.714388, 0.2461457, -5.453972],
  [1.695897, 0.2464719, -5.452736],
  [1.678794, 0.2467746, -5.451477],
  [1.661304, 0.2470852, -5.450073],
  [1.644818, 0.2473788, -5.44864],
  [1.62674, 0.2477019, -5.446948],
  [1.608751, 0.2480244, -5.445137],
  [1.592758, 0.2483122, -5.443417],
  [1.574803, 0.2486364, -5.441367],
  [1.558985, 0.2489229, -5.439452],
  [1.541268, 0.249245, -5.437187],
  [1.524271, 0.2495551, -5.434892],
  [1.508035, 0.2498524, -5.43259],
  [1.490378, 0.250177, -5.429961],
  [1.474875, 0.250463, -5.427546],
  [1.457453, 0.2507857, -5.424709],
  [1.442099, 0.2510711, -5.422101],
  [1.424871, 0.2513926, -5.419056],
  [1.407779, 0.2517129, -5.415905],
  [1.392646, 0.2519976, -5.41301],
  [1.375851, 0.2523149, -5.409676],
  [1.360564, 0.2526048, -5.406531],
  [1.343619, 0.2529276, -5.402924],
  [1.332422, 0.2531416, -5.400467],
  [1.312101, 0.2535317, -5.395862],
  [1.295538, 0.2538514, -5.391966],
  [1.28083, 0.2541364, -5.388397],
  [1.26442, 0.2544558, -5.384294],
  [1.25348, 0.2546696, -5.381486],
  [1.233909, 0.2550538, -5.376318],
  [1.21777, 0.2553723, -5.371914],
  [1.203262, 0.2556601, -5.367845],
  [1.187234, 0.2559794, -5.363225],
  [1.172945, 0.2562654, -5.358995],
  [1.158002, 0.256566, -5.354461],
  [1.142392, 0.2568817, -5.349599],
  [1.128564, 0.2571625, -5.345183],
  [1.113038, 0.2574795, -5.340103],
  [1.100928, 0.257728, -5.33605],
  [1.083671, 0.2580839, -5.330135],
  [1.070036, 0.2583666, -5.325344],
  [1.055072, 0.2586786, -5.319965],
  [1.040035, 0.2589938, -5.31443],
  [1.02669, 0.259275, -5.309407],
  [1.011922, 0.259588, -5.303727],
  [0.998682, 0.2598701, -5.298524],
  [0.9888513, 0.2600805, -5.294592],
  [0.9718986, 0.2604454, -5.287672],
  [0.9560525, 0.2607888, -5.28104],
  [0.9430587, 0.2610721, -5.275485],
  [0.9287887, 0.2613851, -5.269258],
  [0.9160581, 0.2616659, -5.26359],
  [0.9019613, 0.2619788, -5.257188],
  [0.889658, 0.2622536, -5.251493],
  [0.8758507, 0.2625637, -5.244975],
  [0.8620539, 0.2628757, -5.238329],
  [0.8498943, 0.2631524, -5.232362],
  [0.8361793, 0.2634664, -5.225501],
  [0.8244886, 0.2637359, -5.219546],
  [0.8109994, 0.2640487, -5.212546],
  [0.7978783, 0.2643552, -5.205605],
  [0.7859688, 0.2646351, -5.199189],
  [0.772963, 0.264943, -5.192055],
  [0.7614551, 0.2652172, -5.185631],
  [0.7485743, 0.2655263, -5.178309],
  [0.7372575, 0.2657997, -5.171765],
  [0.7244115, 0.2661123, -5.164204],
  [0.7131448, 0.2663884, -5.157454],
  [0.7005975, 0.2666981, -5.149806],
  [0.6896377, 0.2669707, -5.14301],
  [0.6773596, 0.2672782, -5.135264],
  [0.6652098, 0.2675849, -5.127461],
  [0.6544623, 0.2678582, -5.120441],
  [0.6424994, 0.2681649, -5.112494],
  [0.631866, 0.2684395, -5.105313],
  [0.6201346, 0.2687449, -5.097253],
  [0.6096854, 0.2690191, -5.089955],
  [0.5983472, 0.269319, -5.081904],
  [0.586853, 0.2696256, -5.0736],
  [0.5768316, 0.269895, -5.066239],
  [0.565609, 0.2701993, -5.05786],
  [0.5556231, 0.2704724, -5.050281],
  [0.5446885, 0.2707739, -5.041846],
  [0.5348315, 0.271048, -5.034117],
  [0.5240488, 0.2713505, -5.025522],
  [0.514461, 0.2716219, -5.017755],
  [0.5038064, 0.2719262, -5.008981],
  [0.494401, 0.2721972, -5.001108],
  [0.4841599, 0.272495, -4.992398],
  [0.4738989, 0.2727962, -4.983521],
  [0.4648483, 0.2730645, -4.975564],
  [0.4551799, 0.2733536, -4.966928],
  [0.4468174, 0.2736061, -4.959342],
  [0.4360993, 0.2739327, -4.94946],
  [0.4273634, 0.2742018, -4.941265],
  [0.417793, 0.2744994, -4.932144],
  [0.4091308, 0.2747715, -4.923751],
  [0.3997376, 0.2750697, -4.9145],
  [0.3914452, 0.2753356, -4.906199],
  [0.3822408, 0.2756338, -4.896836],
  [0.3731623, 0.2759312, -4.887439],
  [0.3651645, 0.2761962, -4.879025],
  [0.3562419, 0.2764949, -4.869484],
  [0.3484604, 0.2767583, -4.861025],
  [0.3396683, 0.2770592, -4.851306],
  [0.332005, 0.2773245, -4.842693],
  [0.323612, 0.2776184, -4.833103],
  [0.3161376, 0.2778831, -4.824419],
  [0.3078129, 0.2781815, -4.814583],
  [0.300652, 0.2784413, -4.805978],
  [0.2926464, 0.2787352, -4.796197],
  [0.2855108, 0.2790003, -4.787329],
  [0.2776573, 0.2792958, -4.777399],
  [0.2707145, 0.2795604, -4.768468],
  [0.2630949, 0.2798545, -4.758495],
  [0.2556176, 0.2801471, -4.748528],
  [0.2489667, 0.2804108, -4.739505],
  [0.2417474, 0.2807009, -4.729537],
  [0.2353766, 0.2809604, -4.720585],
  [0.2281976, 0.2812568, -4.710314],
  [0.2220075, 0.2815161, -4.701298],
  [0.215327, 0.2817997, -4.691391],
  [0.2093344, 0.2820579, -4.682343],
  [0.2025864, 0.2823528, -4.671966],
  [0.1968255, 0.2826084, -4.662939],
  [0.1903756, 0.2828988, -4.652644],
  [0.1847434, 0.2831564, -4.643483],
  [0.1790032, 0.2834229, -4.633973],
  [0.1724911, 0.2837302, -4.622965],
  [0.1669836, 0.2839946, -4.613463],
  [0.1611996, 0.2842768, -4.603285],
  [0.1559522, 0.2845371, -4.593867],
  [0.150789, 0.2847974, -4.58442],
  [0.1457839, 0.285054, -4.575084],
  [0.1397302, 0.2853701, -4.563543],
  [0.1348886, 0.2856278, -4.554109],
  [0.1295755, 0.2859158, -4.543529],
  [0.1249561, 0.2861709, -4.534132],
  [0.1202247, 0.2864371, -4.524303],
  [0.1153886, 0.2867145, -4.51403],
  [0.1110229, 0.2869698, -4.504549],
  [0.1067593, 0.287224, -4.49509],
  [0.1020958, 0.2875078, -4.4845],
  [0.09753442, 0.2877916, -4.473883],
  [0.09350872, 0.2880476, -4.464284],
  [0.08915782, 0.2883304, -4.453656],
  [0.08533454, 0.2885845, -4.44408],
  [0.08121872, 0.2888646, -4.43351],
  [0.07753968, 0.2891208, -4.423814],
  [0.0735538, 0.2894053, -4.413026],
  [0.07010984, 0.2896573, -4.403452],
  [0.06634974, 0.2899395, -4.392708],
  [0.06306553, 0.2901926, -4.383057],
  [0.05988407, 0.290444, -4.373448],
  [0.05675077, 0.2906981, -4.363719],
  [0.05338931, 0.2909787, -4.352962],
  [0.05022645, 0.2912508, -4.342511],
  [0.04728627, 0.2915114, -4.332482],
  [0.04452276, 0.2917638, -4.322754],
  [0.04156709, 0.2920426, -4.311996],
  [0.03897715, 0.292295, -4.302238],
  [0.03633308, 0.2925615, -4.291923],
  [0.03441501, 0.2927609, -4.284195],
  [0.03142095, 0.2930835, -4.271674],
  [0.02920032, 0.2933328, -4.261985],
  [0.0267694, 0.2936168, -4.250934],
  [0.02473259, 0.2938648, -4.241273],
  [0.02274227, 0.2941172, -4.231431],
  [0.02066565, 0.2943925, -4.22068],
  [0.01887751, 0.2946409, -4.210972],
  [0.01718402, 0.2948871, -4.201338],
  [0.01537323, 0.2951643, -4.190487],
  [0.01385069, 0.2954102, -4.18085],
  [0.01240396, 0.2956566, -4.171181],
  [0.01102161, 0.295906, -4.161395],
  [0.009595156, 0.2961802, -4.150619],
  [0.008378983, 0.2964306, -4.140776],
  [0.007139444, 0.2967053, -4.129971],
  [0.006118774, 0.29695, -4.120342],
  [0.005188465, 0.2971915, -4.110832],
  [0.004223108, 0.2974662, -4.100006],
  [0.003450394, 0.2977098, -4.090405],
  [0.002678394, 0.2979822, -4.079662],
  [0.00214386, 0.2981948, -4.071274],
  [0.001544476, 0.2984679, -4.060501],
  [0.001092434, 0.2987115, -4.050885],
  [0.000679493, 0.2989838, -4.040136],
  [0.0003936291, 0.2992266, -4.030547],
  [0.0001854897, 0.2994691, -4.020969],
  [4.506111e-5, 0.2997384, -4.01033],
  [2.384186e-7, 0.2999787, -4.000844],
  [0, 0.3, -4],
  [0, 0.3, -4],
  [0, 0.3, -4],
];